module.exports = __webpack_public_path__ + "img/face26.0ed25734.gif";